module.exports = __webpack_public_path__ + "static/media/madness2020logo.25fb52aa.png";